import { CommodityMilestone, Material } from '@bechtel/types';
import { MutableRefObject } from 'react';
import { MilestoneIdentifier } from '~/detail/types';
export interface CommodityProgressStepBarProps {
  material: Material | null | undefined;
}

export enum PlanningMaterialStatus {
  MRR = 'MRR',
  MWR = 'MWR',
  ISSUED = 'ISSUED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export interface MaterialStatusTextProps {
  material: Material | null | undefined;
}

export interface MilestoneDroppableProps {
  draggableId: string;
  droppableId: string;
  commodityId: string;
  commodityMilestones: CommodityMilestone[];
  setSelectedMilestoneDraggableIds: (value: string[] | []) => void;
  selectedMilestoneDraggableIds: string[];
  draggingMilestoneId: string;
  milestoneIdentifiers: MutableRefObject<Map<string, MilestoneIdentifier>>;
}

export interface MilestoneDraggableProps {
  draggableId: string;
  dragIndex: number;
  commodityMilestone: CommodityMilestone;
  setSelectedMilestoneDraggableIds: (value: string[] | []) => void;
  selectedMilestonesCount: number;
  selectedMilestoneIndex: number;
  isGhosting: boolean;
  milestoneIdentifiers: MutableRefObject<Map<string, MilestoneIdentifier>>;
  planningAiRequestId?: string | null;
}
